import { render } from "./ProsesPengaturanIzin.vue?vue&type=template&id=bffac390"
import script from "./ProsesPengaturanIzin.vue?vue&type=script&lang=js"
export * from "./ProsesPengaturanIzin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__